import { cn } from "../lib/utils"

export const Paragraph = ({ children, className }) => (
  <div className={cn("mb-4 text-base", className)}>{children}</div>
)
